export const ROUTES = {
  HOME: '/',
  DASHBOARD: '/dashboard',

  // Auth
  AUTH_CALLBACK: '/auth/callback',
  AUTH_LOGIN: '/auth/login',
  AUTH_LOGGED_OUT: '/auth/logged-out',
  AUTH_REGISTER: '/auth/register',

  // Integration application
  INTEGRATION_BASE: '/integration',
  INTEGRATION_DASHBOARD: '/integration/dashboard',
  INTEGRATION_HOME: '/integration/dashboard',
  INTEGRATION_DOCUMENTS: '/integration/documents',
  INTEGRATION_INBOUND_MESSAGES: '/integration/inbound-messages',
  INTEGRATION_GENERATE: '/integration/generate',
  INTEGRATION_FLOWS: '/integration/flows',
  INTEGRATION_PUBLISH_CENTER: '/integration/flows/publish',
  INTEGRATION_FLOW_BUILDER: '/integration/flows/builder',
  INTEGRATION_OPERATION_FLOWS: '/integration/operations/flows',
  INTEGRATION_EXECUTIONS: '/integration/executions',
  INTEGRATION_DLQ: '/integration/dlq',
  INTEGRATION_EXCHANGES: '/integration/operations/exchanges',
  INTEGRATION_COMMAND_CENTER: '/integration/operations/command-center',
  INTEGRATION_MARITIME: '/integration/operations/maritime',
  INTEGRATION_SCHEMAS: '/integration/schemas',
  INTEGRATION_MAPPING_DESIGNER: '/integration/mapping-designer',
  INTEGRATION_TEST_LAB: '/integration/test-lab',
  INTEGRATION_CONNECTOR_CONSOLE: '/integration/connectors',
  INTEGRATION_CONNECTORS: '/integration/config/connectors',
  INTEGRATION_CONNECTOR_INSTANCES: '/integration/config/connector-health',
  INTEGRATION_INBOUND_POLICIES: '/integration/config/inbound-policies',
  INTEGRATION_PARTNERS: '/integration/config/partners',
  INTEGRATION_SECRETS: '/integration/config/secrets',
  INTEGRATION_RUNTIME_MAPPINGS: '/integration/mappings',
  INTEGRATION_RUNTIME_TEMPLATES: '/integration/templates',
  INTEGRATION_RUNTIME_VALIDATION_RULES: '/integration/validation-rules',
  INTEGRATION_MAPPINGS: '/integration/config/mappings',
  INTEGRATION_TEMPLATES: '/integration/config/templates',
  INTEGRATION_VALIDATION_RULES: '/integration/config/validation-rules',
  INTEGRATION_SETTINGS: '/integration/settings',
  INTEGRATION_AS2: '/integration/as2',
  INTEGRATION_AS2_OUTBOUND_MESSAGES: '/integration/as2/outbound-messages',
  INTEGRATION_AS2_INBOUND_MESSAGES: '/integration/as2/inbound-messages',
  INTEGRATION_AS2_DLQ: '/integration/as2/dlq',
  INTEGRATION_AS2_CERTIFICATES: '/integration/as2/certificates',
  INTEGRATION_AS2_TRANSPORT_PROFILES: '/integration/as2/transport-profiles',

  // Gestion des Acces application
  GESTION_ACCESS_BASE: '/gestion-access',
  GESTION_ACCESS_HOME: '/gestion-access/dashboard',
  GESTION_ACCESS_DASHBOARD: '/gestion-access/dashboard',
  GESTION_ACCESS_REQUESTS: '/gestion-access/requests',
  GESTION_ACCESS_VALIDATION: '/gestion-access/validation',
  GESTION_ACCESS_ZONES: '/gestion-access/zones',
  GESTION_ACCESS_DOCUMENTS: '/gestion-access/documents',
  GESTION_ACCESS_ADMIN: '/gestion-access/admin',
  GESTION_ACCESS_AUDIT: '/gestion-access/audit',

  // Declaration Sommaire application
  DECLARATION_SOMMAIRE_BASE: '/declaration-sommaire',
  DECLARATION_SOMMAIRE_HOME: '/declaration-sommaire',
  DECLARATION_SOMMAIRE_DASHBOARD: '/declaration-sommaire',
  DECLARATION_SOMMAIRE_DECLARATIONS: '/declaration-sommaire/declarations',
  DECLARATION_SOMMAIRE_NEW: '/declaration-sommaire/declarations/new',
  DECLARATION_SOMMAIRE_BADS: '/declaration-sommaire/bads',
  DECLARATION_SOMMAIRE_VALIDATION: '/declaration-sommaire/validation-issues',
  DECLARATION_SOMMAIRE_HISTORY: '/declaration-sommaire/history',
  DECLARATION_SOMMAIRE_REFERENCE_DATA: '/declaration-sommaire/reference-data',
  DECLARATION_SOMMAIRE_ADMINISTRATION: '/declaration-sommaire/administration',

  // Entry Summary Declaration application
  ENS_BASE: '/ens',
  ENS_HOME: '/ens',

  // OSS Referential application
  REFERENTIAL_BASE: '/referential',
  REFERENTIAL_HOME: '/referential',
  REFERENTIAL_ITEMS: '/referential/items',
  REFERENTIAL_CATEGORIES: '/referential/categories',
  REFERENTIAL_DOMAINS: '/referential/domains',
  REFERENTIAL_IMPORTS: '/referential/imports',
  REFERENTIAL_VALIDATE: '/referential/validate',
  REFERENTIAL_LOOKUPS: '/referential/lookups',
  REFERENTIAL_CUSTOMS_OPERATORS: '/referential/customs-operators',
  REFERENTIAL_OPERATORS: '/referential/operators',
  REFERENTIAL_PACKAGE_TYPES: '/referential/package-types',
  REFERENTIAL_STORAGE_LOCATIONS: '/referential/storage-locations',

  // Maritime Operations application
  MARITIME_BASE: '/maritime',
  MARITIME_HOME: '/maritime',
  MARITIME_DASHBOARD: '/maritime',
  MARITIME_VESSELS: '/maritime/vessels',
  MARITIME_VESSEL_CREATE: '/maritime/vessels/new',
  MARITIME_VESSEL_PENDING: '/maritime/vessels/pending',
  MARITIME_VESSEL_LIVE: '/maritime/vessels/live',
  MARITIME_VESSEL_CALLS: '/maritime/vessel-calls',
  MARITIME_MOVEMENTS: '/maritime/movements',
  MARITIME_SERVICES: '/maritime/services',
  MARITIME_PLANNING: '/maritime/planning',
  MARITIME_TRACKING: '/maritime/tracking',
  MARITIME_DOCUMENTS: '/maritime/documents',
  MARITIME_NOTIFICATIONS: '/maritime/notifications',
  MARITIME_PMIS_SYNC: '/maritime/pmis-sync',

  // Users
  USERS: '/users',
  USER_NEW: '/users/new',
  USER_DETAIL: '/users/:id',

  // Organizations
  ORGANIZATIONS: '/organizations',
  ORGANIZATION_NEW: '/organizations/new',
  ORGANIZATION_DETAIL: '/organizations/:id',

  // Authorization
  AUTHORIZATION: '/authorization',
  APPLICATIONS: '/applications',

  // Audit
  AUDIT: '/audit',

  // Profile
  PROFILE: '/profile',
  PREFERENCES: '/settings/preferences',

  // Errors
  UNAUTHORIZED: '/unauthorized',
  FORBIDDEN: '/forbidden',
  NOT_FOUND: '/404',
} as const;

export type RoutePath = (typeof ROUTES)[keyof typeof ROUTES];

export function userDetailPath(id: string): string { return `/users/${id}`; }
export function organizationDetailPath(id: string): string { return `/organizations/${id}`; }
